export const API_URL = process.env.VUE_APP_API_URL || '/api/v1/'
export const API_REALM = process.env.VUE_APP_API_REALM || '17524e10a6874978' //'6ede5e8bf92ab202'
export const CDN_URL = process.env.VUE_APP_CDN_URL || '/public/content/'
export const NO_MIGRATE = process.env.VUE_APP_NO_MIGRATE === 'true'
export default API_URL
